const styles = {
  subTitle: {
    margin: '16px 0',

    '& > p': {
      fontSize: '14px',
    },
  },

  tables: {
    display: 'grid',
    gridTemplateColumns: '1fr  1fr',
    gridColumnGap: '56px',
  },
  description: {
    '& > p': {
      fontSize: '14px',
    },
  },
}

export default styles
